import { lazy, Suspense } from "react";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import { SocialProofNotification } from "@/components/SocialProofNotification";
import { Footer } from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";

// Lazy load non-critical components for better initial load performance
const Features = lazy(() => import("@/components/Features"));
const HowItWorks = lazy(() => import("@/components/HowItWorks"));
const WhyDifferent = lazy(() => import("@/components/WhyDifferent"));
const Testimonials = lazy(() => import("@/components/Testimonials"));
const FinalCTA = lazy(() => import("@/components/FinalCTA"));
const LiveChatWidget = lazy(() => import("@/components/LiveChatWidget"));

// Loading fallback component
const SectionLoader = () => (
  <div className="py-12 flex items-center justify-center">
    <div className="animate-pulse text-muted-foreground">Loading...</div>
  </div>
);

const Index = () => {
  return (
    <>
      <SEOHead 
        title="LaunchToRevenue™ | All-in-One Digital Business Ecosystem"
        description="More than a course — LaunchToRevenue™ gives you the tools, AI systems, and private community to build, automate, and monetize your brand — all in one place."
        keywords="digital business ecosystem, AI business tools, affiliate program, business dashboard, content planner, goal planner, business automation, private community, monetization tools, online business platform"
        type="course"
      />
      <Navigation />
      <main className="min-h-screen pt-16">
        <Hero />
        <Suspense fallback={<SectionLoader />}>
          <Features />
        </Suspense>
        <Suspense fallback={<SectionLoader />}>
          <HowItWorks />
        </Suspense>
        <Suspense fallback={<SectionLoader />}>
          <WhyDifferent />
        </Suspense>
        <Suspense fallback={<SectionLoader />}>
          <Testimonials />
        </Suspense>
        <Suspense fallback={<SectionLoader />}>
          <FinalCTA />
        </Suspense>
      </main>
      <Footer />
      <SocialProofNotification />
      <Suspense fallback={null}>
        <LiveChatWidget />
      </Suspense>
    </>
  );
};

export default Index;
